module.exports = __webpack_public_path__ + "images/151_160.jpg";